import React from 'react';
import PropTypes from 'prop-types';

import { ContentSet } from 'components/Shared/Scaffolding';
import Panel, { PanelTitle } from 'components/Shared/Panel';
import { SCAFFOLDING } from 'theme';
import SaveForm from 'components/Save/SaveForm';
import withCancel from 'components/Shared/PanelCancel';
import { useRecoilState } from 'recoil';
import { currentMapIdState } from 'modules/map';

const propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

const SavePanel = ({ open, onClose, onCancel }) => {
    const [mapId] = useRecoilState(currentMapIdState);
    return (
        <Panel open={open} onClose={onCancel}>
            <ContentSet spacing={SCAFFOLDING.GUTTER} padding={SCAFFOLDING.GUTTER}>
                <PanelTitle>Save Map</PanelTitle>
                <SaveForm id={mapId} onClose={onClose} onCancel={onCancel} />
            </ContentSet>
        </Panel>
    );
};

SavePanel.propTypes = propTypes;

export default withCancel({ form: 'save' })(SavePanel);
